export class Session {
    sessionId:string;
    purpose:string;
    idQueues:string[];
    estado:string;
    wrapup:string;
    fecha:string;
    conversationid:string;
}
